import {Component} from '@angular/core';


enum CaseStatus {
  Available,
  Assigned,
  Dismissed,
  Submitted,
  Flagged,
  Unflagged
}

export enum OfrAnnualReportStatus {
  Draft,
  Submitted
}

export class Routes {
  public static Dashboard = '/dashboard';
  public static Login = '/login';
};
export  class API {
  public static  ResetPassord = '/Account/ResetPassword';
  public static ForgetPassword = '/Account/ForgotPassword';
  public static Register = '/Account/Register';
  public static RequestConfirmation = '/Account/RequestConfirmation';
  public static LookUps = '/user/lookups';
  public static SetUserAccess = '/Account/SetAccountStatus';
}
export class StorageConstants {
  // public static AccessToken = 'accessToken';
  public static TokenExpires = 'tokenExpires';
  // public static RefreshToken = 'refreshToken';
  public static Access = 'Access';
  public static DashboardInit = 'dashboardInit';
  public static BearerToken = 'bearerToken';
  public static HeartbeatID = 'heartbeatId';
}
export class EventTypes {
  public static AlertMessage = 'alertMessage';
  public static EditUser = 'userEdit';
  public static CaseCommentThread = 'caseCommentThread';
  public static CaseDetails = 'caseDetails';
  public static CaseList = 'caseList';
}

export class ErrorTypes {
  public static CreateTokenError = 'CreateToken';
  public static ResetPasswordError = 'ResetPassword';
}
